import { Box, Typography } from "@mui/material";
import React from "react";
import { getAccessibleBadgeColors } from "../../utils/contrast";
import { Link } from "react-router-dom";
import SmartImage from "./SmartImage";

function NewsItemLateral({
    date,
    image,
    title,
    description,
    link,
    categorie,
    categorieColor,
    isMobile
}) {
    function formatDate() {
        const months = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        ];
        const newDate = new Date(date);

        return `${newDate.getDate()} de ${
            months[newDate.getMonth()]
        } de ${newDate.getFullYear()}`;
    }

    return (
        <Link
            to={`/noticia?link=${link}`}
            rel="noreferrer"
            style={{
                textDecoration: "none",
            }}
        >
            <Box marginBottom={2} display="flex" flexDirection={isMobile ? "column" : "row"} gap={2}>
                <SmartImage
                    image={image}
                    width={"300px"}
                    height={"200px"}
                    alt={title || "imagem de capa da noticia"}
                    style={{
                        objectFit: "fill",
                        minWidth: "300px",
                    }}
                />
                <Box>
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="400"
                        fontSize="12px"
                        lineHeight="14px"
                    >
                        {formatDate()}
                    </Typography>
                    <Box
                        style={{
                            width: "fit-content",
                            padding: "2px 12px",
                            borderRadius: 50,
                            ...getAccessibleBadgeColors(categorieColor),
                        }}
                        marginY={1}
                    >
                        <Typography
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="700"
                            fontSize="12px"
                            lineHeight="16px"
                            letterSpacing={"0.1em"}
                        >
                            {categorie}
                        </Typography>
                    </Box>
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="600"
                        fontSize="16px"
                        lineHeight="20px"
                    >
                        {title}
                    </Typography>
                </Box>
            </Box>
        </Link>
    );
}

export default NewsItemLateral;
